module.exports = __webpack_public_path__ + "img/秩序维护巡检@3x.235a81a5.png";